import { render } from "./News30.vue?vue&type=template&id=73cc0e88"
import script from "./News30.vue?vue&type=script&lang=js"
export * from "./News30.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__